import { IconProps } from '../Icon';

export const InviteOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 512 512"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m464.773 128.277-136-103.729c-42.848-32.682-102.699-32.682-145.547 0l-136 103.729c-29.572 22.555-47.226 58.224-47.226 95.414v168.271c0 66.168 53.832 120 120 120h272c66.168 0 120-53.832 120-120v-168.271c0-37.19-17.654-72.859-47.227-95.414zm7.227 263.686c0 44.112-35.888 80-80 80h-272c-44.112 0-80-35.888-80-80v-168.272c0-24.794 11.77-48.572 31.484-63.609l136-103.729c14.284-10.893 31.4-16.341 48.516-16.341s34.232 5.447 48.516 16.341l136 103.729c19.714 15.037 31.484 38.815 31.484 63.609zm-43.1-146.131c6.7 8.781 5.013 21.332-3.77 28.031l-96.355 73.512c-21.425 16.342-47.101 24.513-72.776 24.513s-51.349-8.17-72.772-24.511l-95.355-72.728c-8.782-6.698-10.473-19.248-3.773-28.031 6.698-8.783 19.247-10.475 28.031-3.773l95.355 72.728c28.564 21.787 68.465 21.787 97.031 0l96.354-73.51c8.779-6.701 21.332-5.013 28.03 3.769zm-252.9-52.869c0-11.046 8.954-20 20-20h40v-40c0-11.046 8.954-20 20-20s20 8.954 20 20v40h40c11.046 0 20 8.954 20 20s-8.954 20-20 20h-40v40c0 11.046-8.954 20-20 20s-20-8.954-20-20v-40h-40c-11.046 0-20-8.954-20-20z" />
  </svg>
);
